<template>
  <normal-dialog
    :visible="visible"
    :before-close="resetDialog"
    @update:visible="updateVisibleHandle"
    class="ParamsDetail"
  >
    <template slot="title">基本信息</template>
    <form-area title="基本信息">
      <form-line>
        <form-item label="参数名称">{{selected.name}}</form-item>
      </form-line>
      <form-line>
        <form-item label="上行控制">{{selected.cmdCodeUp}}</form-item>
      </form-line>
      <form-line>
        <form-item label="下行控制">{{selected.cmdCode}}</form-item>
      </form-line>
      <form-line>
        <form-item label="参数说明">{{selected.description}}</form-item>
      </form-line>
    </form-area>
    <form-area title="操作记录">
      <div
        class="record-List"
        v-for="(item, index) in selected.adminRecordVoList"
        :key="index"
      >
        <span class="record-Item">{{getOperClassifyName(item.operClassify)}}</span>
        <span class="record-Item">{{item.handler}}</span>
        <span class="record-Item">{{$formatDate(item.createAt)}}</span>
      </div>
    </form-area>
  </normal-dialog>
</template>

<script>
const dialogMixin = manageShell.default.mixinModule.Dialog;

export default {
  mixins: [dialogMixin],
};
</script>

<style lang="scss">
.ParamsDetail {
  .FormItem {
    .FormItem-content {
      width: auto;
    }
  }
}
</style>
